import { uniq, isEqual } from 'lodash';
import moment from 'moment';
import types from './types';

import createMetadataAPIReducer from '../../utils/api-metadata-reducer';

const initialState = {
  byId: {},
  byUserAndGroupId: {},
  errorTimes: [],
  lastError: null,
  error: null,
  lastFetch: null,
  loading: false,
  fullFetchComplete: false,
  paginationStatus: { page: null, perPage: null, total: null, pagesLoaded: [] }
};

const defaultReducer = createMetadataAPIReducer({ baseType: 'ACTIVE_PERIODS' });
const emptyArray = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CLEAR_ACTIVE_PERIODS: {
      const { userId, groupId } = action.payload;
      if (userId == null || groupId == null) return state;

      const newById = { ...state.byUserAndGroupId };
      const groupMap = newById[userId] ? { ...newById[userId] } : {};
      delete groupMap[groupId];

      if (Object.keys(groupMap).length === 0) {
        delete newById[userId];
      } else {
        newById[userId] = groupMap;
      }

      return {
        ...state,
        byUserAndGroupId: newById
      };
    }
    case types.SUCCESS: {
      const activePeriods = action.payload.data;

      let newById = { ...state.byUserAndGroupId };

      const userGroupKeys = uniq(activePeriods.map(c => `${c.user_id}-${c.group_id}`));

      if (action.replace) {
        for (const key of userGroupKeys) {
          const [userId, groupId] = key.split('-');
          const groupMap = newById[userId] ? { ...newById[userId] } : {};
          delete groupMap[groupId];

          if (Object.keys(groupMap).length === 0) {
            delete newById[userId];
          } else {
            newById[userId] = groupMap;
          }
        }
      }

      for (const c of activePeriods) {
        newById[c.user_id] = newById[c.user_id] || {};
        newById[c.user_id][c.group_id] = newById[c.user_id][c.group_id] || emptyArray;
        newById[c.user_id][c.group_id] = [...newById[c.user_id][c.group_id], c];
      }

      for (const key of userGroupKeys) {
        const [userId] = key.split('-');
        if (isEqual(newById[userId], state.byUserAndGroupId[userId])) newById[userId] = state.byUserAndGroupId[userId];
      }

      return {
        ...state,
        byUserAndGroupId: newById,
        lastFetch: moment().format(),
        loading: false
      };
    }
    default: {
      return defaultReducer(state, action);
    }
  }
};
